import { isUndNullEmp } from '../../helpers/main.js';

export class BackupReviewDetail {
    constructor(
        _id = 0,
        _backupReviewId = 0,
        _statusId = 0,
        _scheduledDate = '',
        _executionDate = false,
        _commentary = '',
        _register = '',
    ) {
        this.id = _id;
        this.backupReviewId = _backupReviewId;
        this.statusId = _statusId;
        this.scheduledDate = _scheduledDate;
        this.executionDate = _executionDate;
        this.commentary = _commentary;
        this.register = _register;
    }

    static getClassbackupReviewId = () => {
        return 'BackupReviewDetail - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    BackupReviewId: 0,
                    StatusId: 0,
                    ScheduledDate: 10,
                    ExecutionDate: 10,
                    Commentary: 2,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    BackupReviewId: 450,
                    StatusId: 450,
                    ScheduledDate: 30,
                    ExecutionDate: 30,
                    Commentary: 1000,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    backupReviewId: 0,
                    statusId: 0,
                    scheduledDate: 10,
                    executionDate: 10,
                    commentary: 2,
                    register: 10,
                },
                max: {
                    id: 450,
                    backupReviewId: 450,
                    statusId: 450,
                    scheduledDate: 30,
                    executionDate: 30,
                    commentary: 1000,
                    register: 30,
                },
            };
        }
    }

    // static userIdFullPath = ({userId = '', subMethod = ''} = {}) => {
    //     let response = getResponse({ type: 0 });
    //     const currentMethod = 'BackupReviewDetail / userIdFullPath';
    //     try {
    //         if(!isUndNullEmp({data: userId, subMethod: currentMethod})?.result){
    //             userId = userId.replace('~/Images/UserIds/BackupReviewDetail/', `${settings?.backend?.urls?.imageUserIds}${settings?.backend?.urls?.paymentInformations}/`);
    //             response.result = `${settings?.backend?.urls?.api}${userId}`
    //         } else {
    //             response.result = `${settings?.backend?.urls?.api}${settings?.images?.noImage}`;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}<br/>`;
    //     }
    //     return response;
    // }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: BackupReviewDetail.getClassbackupReviewId() })?.result) {
            if (upperCase) {
                return new BackupReviewDetail(
                    obj.Id,
                    obj.BackupReviewId,
                    obj.StatusId,
                    obj.ScheduledDate,
                    obj.ExecutionDate,
                    obj.Commentary,
                    obj.Register,
                );
            } else {
                return new BackupReviewDetail(
                    obj.id,
                    obj.backupReviewId,
                    obj.statusId,
                    obj.scheduledDate,
                    obj.executionDate,
                    obj.commentary,
                    obj.register,
                );
            }
        } else {
            return new BackupReviewDetail();
        }
    }
}